module.exports = __webpack_public_path__ + "static/media/snazzy-elite1.372208e9.png";